import { callAuthorizedGraphQLEndpoint } from '../../../../../Module/graphQL'
import { callAuthorizedGraphQLEndpoint as callAuthorizedPathfinderGraphQLEndpoint } from '../../../../../Module/graphQL/PathFinder/pathFinderGQL'

const getClientRecipientsEmailData = clientId => {
  const query = `query clientRecipientsEmailData($clientId:ID!){
      clientRecipientsEmailData(clientId:$clientId){
       recipients
       cc
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    clientId,
  })
}

const getClientById = clientId => {
  const query = `query getClient($clientId: ID!) {
    clients(clientId: $clientId) {
      nodes {
        id
        name
        isSkipCheckoutEnabled
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    clientId,
  })
}

const getDataByChunks = ({ countryId, includePathfinder, first, skip }) => {
  const query = `query campaignsBuilderData($input: campaignsBuilderDataInput){
      campaignsBuilderData(input: $input){
        nodes {
          id
          campaignId
          startDate
          internalStatus
          flyerType
          flyerWeight
          error
          campaignDuration
          missionsCount
          totalCosts
          taxes
          lastActiveStep
          clientName
          campaignName
          type
          subtype
          submitDate
          internalStatusChangedDate
          paymentIntent
          paymentStatus
          clientId
          isPaymentSkipped
          paymentSkipperId
          dynamicCouponCode
          staticCouponCode
          workflowId
          submitter {
            firstName
            lastName
          }
          cityName
          isArchivedCity
          createdAt
        }
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    countryId,
    includePathfinder,
    first,
    skip,
  })
}

const updateCampaignsCampaignBuilderData = input => {
  const query = `mutation updateCampaignExtraData(
      $input: CampaignExtraDataInput
    ) {
      updateCampaignExtraData(
        input: $input,
      ) { 
        success
        error
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, input)
}

const sendEmail = input => {
  const query = `mutation sendEmail(
      $input: SendEmailInput
    ) {
      sendEmail(
        input: $input,
      ) { 
        success
        recipient
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, input)
}

const getCampaignFlyerInfo = async campaignId => {
  const query = `query 
    ($campaignId:ID!) {
        campaignFlyerInfo(campaignId: $campaignId) {
          s3Link
          flyerName
        }
    }`

  return await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}

const updateSelfServeCampaignData = input => {
  const gql = `mutation($input: SelfServeCampaignDataInput!) {
      updateSelfServeCampaignData(input: $input) {
          success
      }
    }`

  return callAuthorizedPathfinderGraphQLEndpoint(gql, {
    input,
  })
}

const createEDDMInternalFlyerCodes = input => {
  const query = `mutation createEDDMInternalFlyerCodes(
      $input: CreateEDDMInternalFlyerCodesInput!
    ) {
      createEDDMInternalFlyerCodes(
        input: $input,
      ) { 
        success
      }
    }`
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const createCityPlanAndMissionOnSSCampaign = input => {
  const query = `mutation createCityPlanAndMissionOnSSCampaign(
      $input: CreateCityPlanAndMissionOnSSCampaignInput!
    ) {
      createCityPlanAndMissionOnSSCampaign(
        input: $input,
      ) { 
        success
      }
    }`
  return callAuthorizedGraphQLEndpoint(query, { input })
}

export {
  getClientRecipientsEmailData,
  getClientById,
  getDataByChunks,
  updateCampaignsCampaignBuilderData,
  sendEmail,
  getCampaignFlyerInfo,
  updateSelfServeCampaignData,
  createEDDMInternalFlyerCodes,
  createCityPlanAndMissionOnSSCampaign,
}
